import { ActionReducerMap } from '@ngrx/store';
import { GlobalCartState } from './state';
import { cartReducer } from './cart';

export const reducers: ActionReducerMap<GlobalCartState> = {
  cart: cartReducer
};
